import React, { Suspense, lazy } from 'react';
import { HyperText } from '../components/HyperText';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
// Lazy load the ContactForm component
const ContactForm = lazy(() => import('../components/ContactForm'));
const ContactPage = () => {
  return <div className="w-full bg-center bg-cover bg-no-repeat bg-gray-900" style={{
    backgroundImage: `url(https://uploadthingy.s3.us-west-1.amazonaws.com/ib3Dyczi1YEyT6WYET97wp/bgbluee2.png)`
  }} data-id="element-317">
      <div className="pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-24" data-id="element-318">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal px-4" data-id="element-319">
          Contact Us
        </h1>
      </div>
      <div className="py-12 sm:py-16 md:py-24" data-id="element-320">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-321">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 mb-12 sm:mb-16" data-id="element-322">
            <div data-id="element-323">
              <h2 className="text-2xl sm:text-3xl font-light text-white mb-6 sm:mb-8 tracking-normal" data-id="element-324">
                Get In Touch
              </h2>
              <div className="mb-8" data-id="element-325">
                <div className="flex items-start gap-4 mb-4" data-id="element-326">
                  <MapPinIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#89CFF0] flex-shrink-0 mt-1" data-id="element-327" />
                  <div data-id="element-328">
                    <h3 className="text-lg sm:text-xl font-light text-white mb-1 sm:mb-2 tracking-normal" data-id="element-329">
                      Our Location
                    </h3>
                    <p className="text-sm sm:text-base text-gray-400 font-light" data-id="element-330">
                      Flower Mound, TX
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-331">
                  <MailIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#89CFF0] flex-shrink-0 mt-1" data-id="element-332" />
                  <div data-id="element-333">
                    <h3 className="text-lg sm:text-xl font-light text-white mb-1 sm:mb-2 tracking-normal" data-id="element-334">
                      Email
                    </h3>
                    <p className="text-sm sm:text-base text-gray-400 font-light" data-id="element-335">
                      info@hanomihealth.com
                    </p>
                  </div>
                </div>
              </div>
              <div className="h-64 sm:h-80 w-full rounded-xl overflow-hidden border border-gray-700 shadow-sm" data-id="element-336">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d53487.970546558!2d-97.12660755!3d33.0287013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c3c7f58d23015%3A0x21c6e05c9e946d!2sFlower%20Mound%2C%20TX!5e0!3m2!1sen!2sus!4v1650293539279!5m2!1sen!2sus" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Flower Mound, TX Map" data-id="element-337"></iframe>
              </div>
            </div>
            <div className="bg-gray-900/50 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm" data-id="element-338">
              <h2 className="text-2xl sm:text-3xl font-light text-white mb-6 sm:mb-8 tracking-normal" data-id="element-339">
                Send Us a Message
              </h2>
              <Suspense fallback={<div className="space-y-6 animate-pulse" data-id="element-341">
                    {[...Array(5)].map((_, index) => <div key={index} className="h-12 bg-gray-800/70 rounded-lg" data-id="element-342"></div>)}
                    <div className="h-32 bg-gray-800/70 rounded-lg" data-id="element-343"></div>
                    <div className="h-12 bg-gray-800/70 rounded-lg" data-id="element-344"></div>
                  </div>} data-id="element-340">
                <ContactForm data-id="element-345" />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ContactPage;